/* eslint-disable prettier/prettier */
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetStudentDetails Input Action
 */

var studentAPIKey: string = "";
var endPointURL: string = "";

export class GetStudentDetailsInput implements Msdyn365.IActionInput{

    // TODO: Construct the input needed to run the action
    constructor(args: Msdyn365.ICreateActionContext){
         //student = "mjv0GuKrVYYZHv2C4NtjZf4Go4rUj/wLlzLj/mYHT2vRmuJEOl8Sag==";
         //endPointURL = "https://cep-student-dev.azurewebsites.net/api/StudentList";
         studentAPIKey = args.requestContext.app.config.studentAPIKey;
        endPointURL = args.requestContext.app.config.studentAPIEndPoint;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetStudentDetailsData {
    studentsCollection: IStudentDetails[];
}

export interface IStudentDetails {
    EMAIL: string;
    NAME: string;
    DEFAULT: boolean;
    ID: string;
    EVENT_GUID: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetStudentDetailsInput(args);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input:GetStudentDetailsInput, ctx: Msdyn365.IActionContext):Promise<IGetStudentDetailsData> {
    const channelID = ctx.requestContext.channel?.ChannelNaturalId;

    var result = await Msdyn365.sendRequest<IStudentDetails[]>(`${endPointURL}?RetailChannelId=${channelID}&code=${studentAPIKey}`,
    'get')
    .then((response: Msdyn365.IHTTPResponse<IStudentDetails[]>) => {
        return response.data;
    });

    var eventID = result.length? result[0].EVENT_GUID: "";
    var obj: any = new Object();
    if(result.length > 0){
        obj.DEFAULT = false;
        obj.EMAIL = "";
        obj.EVENT_GUID = eventID;
        obj.NAME = "Other";
        obj.ID = "Other";
        result.push(obj);

        result.sort((a, b) => {
            return a.NAME.localeCompare(b.NAME);
        });
    }

    return { studentsCollection: result };
}

export const IGetStudentDetailsAction =  Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetStudentDetailsData>>action,
    input: createInput
});


export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetStudentDetailsData>>action,
    input: createInput
});